<div class="bg-white shadow ring-1 ring-gray-200 rounded-xl">
  <!-- Header -->
  <div
    class="px-6 py-5 flex items-center justify-between border-b border-gray-200 bg-gray-50 rounded-t-xl"
  >
    <h3 class="text-lg font-semibold text-gray-900">Opening Fee Details</h3>
    <button
      *ngIf="!user?.has_paid_opening_fees"
      (click)="bypassOpeningFee()"
      [disabled]="bypassing"
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-500 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span *ngIf="bypassing">Bypassing...</span>
      <span *ngIf="!bypassing">Bypass Fee</span>
    </button>
  </div>

  <!-- Body -->
  <div class="px-6 py-6" *ngIf="!loading; else loadingState">
    <dl class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3">
      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">Fully Paid</dt>
        <dd class="mt-1 text-sm font-semibold text-gray-900">
          {{ openingFee?.is_fully_paid ? "YES" : "NO" }}
        </dd>
      </div>

      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">Remaining Fee</dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ openingFee?.remaining_fee | currency : "USD" }}
        </dd>
      </div>

      <div class="sm:col-span-1">
        <dt class="text-sm font-medium text-gray-500">Proof Type</dt>
        <dd class="mt-1 text-sm text-gray-900">
          {{ openingFee?.proof_type || "-" }}
        </dd>
      </div>

      <!-- Dynamic fields -->
      <ng-container
        *ngFor="
          let field of [
            'sender_name',
            'sender_bank_name',
            'sender_account_number',
            'sender_routing_number',
            'sender_iban',
            'sender_wallet_address',
            'sender_transaction_hash'
          ]
        "
      >
        <div class="sm:col-span-1" *ngIf="openingFee?.[field]">
          <dt class="text-sm font-medium text-gray-500">
            {{ formatFieldName(field) }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 truncate">
            {{ openingFee[field] }}
          </dd>
        </div>
      </ng-container>

      <div class="sm:col-span-1" *ngIf="openingFee?.document?.trim()">
        <dt class="text-sm font-medium text-gray-500">Document</dt>
        <dd class="mt-1">
          <a
            (click)="downloadBase64File(openingFee.document, 'open')"
            class="inline-flex items-center gap-1 text-sm font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 4v16m8-8H4"
              />
            </svg>
            Open
          </a>
        </dd>
      </div>
    </dl>
  </div>

  <!-- Loading State -->
  <ng-template #loadingState>
    <div class="flex flex-col items-center justify-center py-12 text-gray-500">
      <div
        class="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"
      ></div>
      <p class="mt-4 text-sm font-medium">Loading opening fee data...</p>
    </div>
  </ng-template>
</div>
